// extracted by mini-css-extract-plugin
export default {"root":"StyledWith_root__19mYv","title":"StyledWith_title__1cPUx","list":"StyledWith_list__3YPVC","item":"StyledWith_item__3W7ux","desktop":"StyledWith_desktop__2qgX1"};